// extracted by mini-css-extract-plugin
export default {"art":"picture_art__3H32B"};